import React, { useState } from 'react';
import { ManageOrderTable } from '..';
import { LabeledInput, SelectInput } from '../../Components';
import './confirmed.css';
const Confirmed = () => {
    // const [orderID, setOrderId] = useState('');
    // const [trackNumber, setTrackNumber] = useState('');
    // const [customerNumber, setCustomerNumber] = useState('');
    // const [invoiceNumber, setInvoiceNumber] = useState('');
    // const [status, setStatus] = useState('All');
    // const [mode, setMode] = useState('All');
    const [orderStatus, setOrderStatus] = useState('NONE');
    return (
        <>
            <div className="manageOrder_confirmed">
                <div className="manageOrder_confirmed_content">
                    {/* <LabeledInput
                        name="order id"
                        value={orderID}
                        changeHandler={(e) => {
                            setOrderId(e.target.value);
                        }}
                        label={'Order ID'}
                    />
                    <LabeledInput
                        name="trancking number"
                        value={trackNumber}
                        changeHandler={(e) => {
                            setTrackNumber(e.target.value);
                        }}
                        label={'Tracking Number'}
                    /> */}
                    {/* <LabeledInput
                    name="customer name"
                    value={customerNumber}
                    changeHandler={(e) => {
                        setCustomerNumber(e.target.value);
                    }}
                    label={'Customer Name'}
                /> */}
                    {/* <LabeledInput
                        name="Invoice number"
                        value={invoiceNumber}
                        changeHandler={(e) => {
                            setInvoiceNumber(e.target.value);
                        }}
                        label={'Invoice Number'}
                    /> */}
                    <div>
                        <SelectInput
                            label="Order Status"
                            outlined={true}
                            value={orderStatus}
                            changeHandler={(e) => {
                                setOrderStatus(e.target.value);
                            }}
                            options={[
                                { name: 'NONE', value: 'NONE' },
                                { name: 'New Orders', value: 'New Orders' },
                                { name: 'Processing', value: 'Processing' },
                                { name: 'Cancelled', value: 'Cancelled' },
                                { name: 'Returned', value: 'Returned' },
                                { name: 'Dispatched', value: 'Dispatched' },
                            ]}
                        />
                    </div>
                    {/* <div>
                    <SelectInput
                        label="Order Status"
                        outlined={true}
                        value={status}
                        changeHandler={(e) => {
                            setStatus(e.target.value);
                        }}
                        options={[
                            { name: 'All', value: 'All' },
                            { name: 'Some', value: 'S' },
                        ]}
                    />
                </div>
                
                <div>
                    <SelectInput
                        label="Shipping Mode"
                        outlined={true}
                        value={mode}
                        changeHandler={(e) => {
                            setMode(e.target.value);
                        }}
                        options={[
                            { name: 'All', value: 'All' },
                            { name: 'Some', value: 'S' },
                        ]}
                    />
                </div> */}
                    {/* <div> */}
                    <button style={{ marginRight: '1rem' }} className="btn-gray">
                        <p>Reset</p>
                    </button>
                    <button className="btn-orange ">
                        <p>Search</p>
                    </button>
                    {/* </div> */}
                </div>
            </div>
            <ManageOrderTable />
        </>
    );
};

export default Confirmed;
